module.exports = __webpack_public_path__ + "static/img/manual-3.9f3764e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/manual-3.png
// module id = 4uK0
// module chunks = 4